import * as Types from '../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateJobAlertMutationVariables = Types.Exact<{
  input: Types.CreateJobAlertInput;
}>;


export type CreateJobAlertMutation = { __typename?: 'Mutation', jobAlert: { __typename?: 'JobAlertMutations', create?: { __typename?: 'CreateJobAlertPayload', jobAlert?: { __typename?: 'JobAlert', id: string, subscriptionState: Types.SubscriptionState, query?: string | null, location?: string | null, searchParams?: string | null } | null } | null } };


export const CreateJobAlertDocument = gql`
    mutation CreateJobAlert($input: CreateJobAlertInput!) {
  jobAlert {
    create(input: $input) {
      jobAlert {
        id
        subscriptionState
        query
        location
        searchParams
      }
    }
  }
}
    `;
export type CreateJobAlertMutationFn = Apollo.MutationFunction<CreateJobAlertMutation, CreateJobAlertMutationVariables>;

/**
 * __useCreateJobAlertMutation__
 *
 * To run a mutation, you first call `useCreateJobAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobAlertMutation, { data, loading, error }] = useCreateJobAlertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobAlertMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobAlertMutation, CreateJobAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobAlertMutation, CreateJobAlertMutationVariables>(CreateJobAlertDocument, options);
      }
export type CreateJobAlertMutationHookResult = ReturnType<typeof useCreateJobAlertMutation>;
export type CreateJobAlertMutationResult = Apollo.MutationResult<CreateJobAlertMutation>;
export type CreateJobAlertMutationOptions = Apollo.BaseMutationOptions<CreateJobAlertMutation, CreateJobAlertMutationVariables>;